<script>
import Layout from '@layouts/main';
import AllowanceForm from '@views/allowances/form';
import beforeLeaveAfterEdit from '@mixins/beforeLeaveAfterEdit';

export default {
  name: 'AllowanceEdit',
  components: {
    Layout,
    AllowanceForm,
  },
  mixins: [beforeLeaveAfterEdit],
  page() {
    return {
      title: `${this.$t('titles.edit_allowance')} #${this.$route.params.id}`,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.allowances'),
          to: { name: 'allowances.index' },
        },
        {
          text: `${this.$t('titles.edit_allowance')} #${this.$route.params.id}`,
          active: true,
        },
      ],
    };
  },
  methods: {
    update() {
      this.setUnchanged();
      this.$router.push({
        name: 'allowances.index',
      });
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <b-card
      :border-variant="!errors.items.length ? 'dark' : 'danger'"
      :header="$t('titles.edit_allowance')"
      header-tag="header"
      :header-bg-variant="!errors.items.length ? 'dark' : 'danger'"
      header-text-variant="white"
      class="mb-3"
    >
      <AllowanceForm :loaded-id="$route.params.id" @submitted="update" @entity-changed="initBeforeLeave" />
    </b-card>
  </Layout>
</template>
